export default __webpack_public_path__ + "static/media/celular_dexpro.e0a3d76d.png";